import { GET_BULK_ACTIONS, GET_BULK_ACTIONS_FAIL, GET_BULK_ACTIONS_SUCCESS } from "../../../constants/maintenance/bulkActionApSwitchConstants/bulkActionApSwitchConstants";

export const bullkActionTasksReducer = (state = { bulkActionTasks: [] }, action) => {
    switch (action.type) {
        case GET_BULK_ACTIONS:
            return {
                ...state,
                bulkActionTasks : [],
                loading: true,
            };
        case GET_BULK_ACTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                bulkActionTasks: action.payload,
            };
        case GET_BULK_ACTIONS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};